<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13.25" height="13.25" viewBox="0 0 13.25 13.25">
    <g transform="translate(-2.375 -2.375)">
      <path d="M13,10.333v3.333A1.333,1.333,0,0,1,11.667,15H4.333A1.333,1.333,0,0,1,3,13.667V6.333A1.337,1.337,0,0,1,4.333,5H7.667M11,3h4V7M7.667,10.333l6.8-6.8" fill="none" stroke="#2c3e50" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" fill-rule="evenodd"/>
    </g>
  </svg>
</template>
